


























import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
@Component({
  name: 'UploadFile'
})
export default class extends Vue {
  @Prop() private isFailVisible!: any
  @Prop() private failData !: []
  // 业务方法

  // 表单取消
  handleClose() {
    this.$emit('handseCloseFail')
  }
  // 确定
  handleSubmit() {
    this.handleClose()
  }
}
